"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableDirections = void 0;
var react_1 = __importDefault(require("react"));
var sort_icon_svg_1 = __importDefault(require("res/img/sort-icon.svg"));
var ascending_icon_svg_1 = __importDefault(require("res/img/ascending-icon.svg"));
var descending_icon_svg_1 = __importDefault(require("res/img/descending-icon.svg"));
var TableDirections;
(function (TableDirections) {
    TableDirections[TableDirections["UP"] = 0] = "UP";
    TableDirections[TableDirections["DOWN"] = 1] = "DOWN";
})(TableDirections = exports.TableDirections || (exports.TableDirections = {}));
var TableHeading = function (_a) {
    var name = _a.name, active = _a.active, sortable = _a.sortable, direction = _a.direction, onChange = _a.onChange;
    var clickHandler = function (e) {
        var newDirection = direction;
        var newName = name;
        if (active)
            newDirection = direction === TableDirections.UP ? TableDirections.DOWN : TableDirections.UP;
        if (active && direction === TableDirections.DOWN) {
            newDirection = TableDirections.UP;
            newName = null;
        }
        onChange(newName, newDirection);
    };
    var imgClassName = name === 'Image' ? 'table-heading-img' : '';
    return (react_1.default.createElement("div", { className: "table-heading " + imgClassName + " flex flex-row flex-space-between", onClick: clickHandler, "aria-selected": active, "data-sortable": sortable },
        react_1.default.createElement("span", null, name),
        sortable &&
            react_1.default.createElement("div", { className: 'icon' }, active && direction === TableDirections.UP ?
                react_1.default.createElement("img", { src: ascending_icon_svg_1.default, alt: 'Ascending' })
                :
                    active && direction === TableDirections.DOWN ?
                        react_1.default.createElement("img", { src: descending_icon_svg_1.default, alt: 'Descending' })
                        :
                            react_1.default.createElement("img", { src: sort_icon_svg_1.default, alt: 'Sort' }))));
};
exports.default = TableHeading;
